import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdminService {

  constructor(private http: Http) { }

  getCompanies(page: number, per: number, keyword: string = null, statusType: string = null) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let params: URLSearchParams = new URLSearchParams();
    params.set('status_type', statusType);
    params.set('page', page.toString());
    params.set('per', per.toString());
    params.set('keyword', keyword);
    let options = new RequestOptions({ headers: headers, search: params });
    return this.http.get(environment.adminDashboardUrl, options)
      .map(res => res.json())
  }

  archiveOrg(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.archiveOrgUrl}/${orgId}.json`, {}, options)
      .map(res => res.json())
  }

  remandOrg(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.remandOrgUrl}/admin/archive_organization/${orgId}.json`, {}, options)
      .map(res => res.json())
  }

  deleteOrg(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.deleteOrgUrl}/${orgId}.json`, options)
      .map(res => res.json())
  }

  downloadFile(orgId: number, type: string) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/documents/download_file.json?file_type=${type}`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/services/admin.service.ts